const toAccountUrl = (href: string): string => (href.startsWith('?') ? `/account${href}` : href);

export default toAccountUrl;
